import React, { useMemo } from 'react';
import { Button } from '@cp/ds/src/components/button';
import { ButtonProps } from '@cp/ds/src/components/button/model';
import { CareerId } from '@common/const/catalog/career';
import { useCareerDeclination } from '@cp/entities/career';
import { Declination } from '@cp/shared/declination';
import { QuizQuestions, useAuthWithQuiz } from '../model';

export interface SpecialistRegistrationButtonProps extends ButtonProps {
  careerId?: CareerId;
  ask?: QuizQuestions;
}

export const SpecialistRegistrationButton: React.FC<SpecialistRegistrationButtonProps> = ({ careerId, ask = [], children, ...props }) => {
  const declination = useCareerDeclination();
  const questions = useMemo((): QuizQuestions => ((careerId ? [] : ['careerId']) as QuizQuestions).concat(ask), [careerId, ask]);
  const auth = useAuthWithQuiz(questions);

  return (
    <Button onClick={() => auth()} {...props}>
      {children || <span>Стать {careerId ? declination(1, careerId, Declination.Instrumental) : 'специалистом'}</span>}
    </Button>
  );
};
